import { defineMessages } from "react-intl";

const messages = defineMessages({
  chart: {
    id: "entityMentions.content.unavailable.chart",
    defaultMessage: "Chart not available",
    description: "Pill shown in place of a mentioned chart that can't be loaded",
  },
  chartTooltip: {
    id: "entityMentions.content.unavailable.chart.tooltip",
    defaultMessage: "This chart may have been hidden or deleted.",
    description: "Tooltip on the pill shown in place of a mentioned chart that can't be loaded",
  },
  company: {
    id: "entityMentions.content.unavailable.company",
    defaultMessage: "Company not available",
    description: "Pill shown in place of a mentioned company that can't be loaded",
  },
  companyTooltip: {
    id: "entityMentions.content.unavailable.company.tooltip",
    defaultMessage: "You don't have access to this company, or it may have been deleted.",
    description: "Tooltip on the pill shown in place of a mentioned company that can't be loaded",
  },
  deal: {
    id: "entityMentions.content.unavailable.deal",
    defaultMessage: "Deal not available",
    description: "Pill shown in place of a mentioned deal that can't be loaded",
  },
  dealTooltip: {
    id: "entityMentions.content.unavailable.deal.tooltip",
    defaultMessage: "You don't have access to this deal, or it may have been deleted.",
    description: "Tooltip on the pill shown in place of a mentioned deal that can't be loaded",
  },
  group: {
    id: "entityMentions.content.unavailable.group",
    defaultMessage: "Group not available",
    description: "Pill shown in place of a mentioned group that can't be loaded",
  },
  groupTooltip: {
    id: "entityMentions.content.unavailable.group.tooltip",
    defaultMessage: "You don't have access to this group, or it may have been deleted.",
    description: "Tooltip on the pill shown in place of a mentioned group that can't be loaded",
  },
  person: {
    id: "entityMentions.content.unavailable.person",
    defaultMessage: "Person not available",
    description: "Pill shown in place of a mentioned person that can't be loaded",
  },
  personTooltip: {
    id: "entityMentions.content.unavailable.person.tooltip",
    defaultMessage: "You don't have access to this person, or they may have been deleted.",
    description: "Tooltip on the pill shown in place of a mentioned person that can't be loaded",
  },
  route: {
    id: "entityMentions.content.unavailable.route",
    defaultMessage: "Route not available",
    description: "Pill shown in place of a mentioned route that can't be loaded",
  },
  routeTooltip: {
    id: "entityMentions.content.unavailable.route.tooltip",
    defaultMessage: "You don't have access to this route, or it may have been deleted.",
    description: "Tooltip on the pill shown in place of a mentioned route that can't be loaded",
  },
  territory: {
    id: "entityMentions.content.unavailable.territory",
    defaultMessage: "Territory not available",
    description: "Pill shown in place of a mentioned territory that can't be loaded",
  },
  territoryTooltip: {
    id: "entityMentions.content.unavailable.territory.tooltip",
    defaultMessage: "You don't have access to this territory, or it may have been deleted.",
    description: "Tooltip on the pill shown in place of a mentioned territory that can't be loaded",
  },
  user: {
    id: "entityMentions.content.unavailable.user",
    defaultMessage: "User not available",
    description: "Pill shown in place of a mentioned user that can't be loaded",
  },
  userTooltip: {
    id: "entityMentions.content.unavailable.user.tooltip",
    defaultMessage: "This user may have been removed from your organization.",
    description: "Tooltip on the pill shown in place of a mentioned user that can't be loaded",
  },
});

export default messages;
